import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import AdminRoute from "./components/AdminRoute";
import AgeGate from "./components/AgeGate";
import Scoreboard from "./pages/Scoreboard";
import Standings from "./pages/Standings";
import TeamDetail from "./pages/TeamDetail";
import StreakLab from "./pages/StreakLab";
import BettingLab from "./pages/BettingLab";
import StrategyAdmin from "./pages/StrategyAdmin";
import BigRoadPage from "./pages/BigRoadPage";
import StrategyLab from "./pages/StrategyLab";
import StakeOptimizer from "./pages/StakeOptimizer";
import AdminSubscriptions from "./pages/AdminSubscriptions";
import AdminBroadcast from "./pages/AdminBroadcast";
import PublicPicks from "./pages/PublicPicks";
import PicksHistory from "./pages/PicksHistory";
import PicksWeekly from "./pages/PicksWeekly";
import Receipts from "./pages/Receipts";
import Contact from "./pages/Contact";
import Subscribe from "./pages/Subscribe";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import ProductLanding from "./pages/ProductLanding";
import ProductTeaser from "./pages/ProductTeaser";
import WnbaPicks from "./pages/WnbaPicks";
import Pricing from "./pages/Pricing";
import MarketsPicks from "./pages/MarketsPicks";
import MarketsAdmin from "./pages/MarketsAdmin";
import GettingStarted from "./pages/GettingStarted";

// Legacy /register route is now redirected to /signup; keeping import path
// in case future PRs want to bring back a no-card admin-invite flow.
import Login from "./pages/Login";
import Register from "./pages/Register"; // eslint-disable-line no-unused-vars
import { Toaster } from "sonner";

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 tape-bg">{children}</main>
      <footer className="border-t border-white/10 py-6 text-center text-[10px] uppercase tracking-[0.3em] text-zinc-600 space-y-1">
        <div>Data · MLB Stats API · Odds · DraftKings via ESPN · Accurate Monkey</div>
        <div className="text-[9px] normal-case tracking-wider text-zinc-700 max-w-3xl mx-auto px-4">
          For entertainment only · 21+ · Not financial or wagering advice · Trade & gamble responsibly · 1-800-GAMBLER
        </div>
        <div className="pt-1">
          <a href="/contact" data-testid="footer-contact-link" className="text-zinc-500 hover:text-white tracking-[0.3em] transition-colors">Contact / Inquiries</a>
          <span className="mx-2 text-zinc-700">·</span>
          <a href="mailto:info@accuratemonkey.com" data-testid="footer-mailto" className="text-zinc-500 hover:text-white normal-case tracking-wider transition-colors">info@accuratemonkey.com</a>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" />
        <AgeGate />
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/signup" replace />} />

          {/* Public (anonymous OK) */}
          <Route path="/" element={<Shell><ProductLanding /></Shell>} />
          <Route path="/sports/mlb" element={<Shell><PublicPicks /></Shell>} />
          <Route path="/sports/wnba" element={<Shell><WnbaPicks /></Shell>} />
          <Route path="/picks" element={<Navigate to="/sports/mlb" replace />} />
          <Route path="/markets/stocks" element={<Shell><MarketsPicks product="stocks" /></Shell>} />
          <Route path="/markets/options" element={<Shell><MarketsPicks product="options" /></Shell>} />
          <Route path="/markets/:product" element={<Shell><ProductTeaser /></Shell>} />
          <Route path="/pricing" element={<Shell><Pricing /></Shell>} />
          <Route path="/getting-started" element={<Shell><GettingStarted /></Shell>} />
          <Route path="/history" element={<Shell><PicksHistory /></Shell>} />
          <Route path="/weekly" element={<Shell><PicksWeekly /></Shell>} />
          <Route path="/receipts" element={<Shell><Receipts /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="/subscribe" element={<Shell><Subscribe /></Shell>} />
          <Route path="/signup" element={<Shell><Signup /></Shell>} />
          <Route path="/account" element={<Shell><Account /></Shell>} />

          {/* Admin-only */}
          <Route path="/scoreboard" element={<AdminRoute><Shell><Scoreboard /></Shell></AdminRoute>} />
          <Route path="/standings" element={<AdminRoute><Shell><Standings /></Shell></AdminRoute>} />
          <Route path="/streaks" element={<AdminRoute><Shell><StreakLab /></Shell></AdminRoute>} />
          <Route path="/betting" element={<AdminRoute><Shell><BettingLab /></Shell></AdminRoute>} />
          <Route path="/strategy" element={<AdminRoute><Shell><StrategyAdmin /></Shell></AdminRoute>} />
          <Route path="/big-road" element={<AdminRoute><Shell><BigRoadPage /></Shell></AdminRoute>} />
          <Route path="/lab" element={<AdminRoute><Shell><StrategyLab /></Shell></AdminRoute>} />
          <Route path="/optimizer" element={<Shell><StakeOptimizer /></Shell>} />
          <Route path="/admin/subscriptions" element={<AdminRoute><Shell><AdminSubscriptions /></Shell></AdminRoute>} />
          <Route path="/admin/broadcast" element={<AdminRoute><Shell><AdminBroadcast /></Shell></AdminRoute>} />
          <Route path="/admin/markets" element={<AdminRoute><Shell><MarketsAdmin /></Shell></AdminRoute>} />
          <Route path="/team/:id" element={<AdminRoute><Shell><TeamDetail /></Shell></AdminRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
